var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitchSmallLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20833 0.0144043H25V13.6213L15.625 22.3686H11.4583L6.25 27.2283V22.3686H0V4.87402L5.20833 0.0144043ZM22.9167 12.6494V1.95825H6.25V16.5371H10.9375V19.9388L14.5833 16.5371H18.75L22.9167 12.6494ZM19.7917 5.35998V11.1915H17.7083V5.35998H19.7917ZM14.0625 5.35998V11.1915H11.9792V5.35998H14.0625Z",
    fill: "#9146FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitchSmallLogo);
export default __webpack_public_path__ + "static/media/twitch-small-logo.5b51760e8b6772b0874fed851618cf22.svg";
export { ForwardRef as ReactComponent };